// extracted by mini-css-extract-plugin
module.exports = {"addToken":"styles_addToken__ISmr5"};